const INDEXED_NAME_RE = /^(.*) (\[\d+\])$/;

/** Translate a name that may carry a server index suffix, e.g. `EPAL_1 [0]`. */
export function translateIndexedName(
  name: string | undefined | null,
  instant: (key: string) => string,
): string {
  const raw = name ?? '';
  const match = INDEXED_NAME_RE.exec(raw);
  if (!match) {
    return instant(raw);
  }
  return `${instant(match[1])} ${match[2]}`;
}
